import { moon, sun } from "./icons";

const STORAGE_KEY = "relay-theme";
export type Theme = "light" | "dark";

export function getTheme(): Theme {
  const current = document.documentElement.dataset.theme;
  return current === "dark" ? "dark" : "light";
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Storage may be unavailable.
  }
  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta) meta.content = theme === "dark" ? "#1b1a18" : "#faf9f5";
  updateThemeButtons();
}

export function toggleTheme(): void {
  applyTheme(getTheme() === "dark" ? "light" : "dark");
}

export function updateThemeButtons(): void {
  const theme = getTheme();
  document.querySelectorAll<HTMLButtonElement>('[data-action="theme"]').forEach((button) => {
    button.innerHTML = theme === "dark" ? sun() : moon();
    const label = theme === "dark" ? "Switch to light theme" : "Switch to dark theme";
    button.setAttribute("aria-label", label);
    button.title = label;
  });
}
